import React from 'react';
import { C } from '../../ColorTokens';

const LABEL_STYLE = {
  display: 'block',
  fontSize: 11,
  fontFamily: "'Space Grotesk', sans-serif",
  fontWeight: 500,
  letterSpacing: '0.5px',
  textTransform: 'uppercase',
  color: C.primary,
  marginBottom: 6,
};

const INPUT_BASE_STYLE = {
  width: '100%',
  paddingTop: '10px',
  paddingBottom: '10px',
  background: 'transparent',
  border: 'none',
  borderBottom: `1px solid ${C.outlineVariant}`,
  borderRadius: 0,
  fontSize: 16,
  color: C.onSurface,
  fontFamily: "'Noto Sans JP', sans-serif",
  outline: 'none',
  transition: 'border-color 0.2s',
  boxSizing: 'border-box',
};

export default function Input({
  label,
  error,
  required,
  icon,
  endAdornment,
  iconRight,      // 後方互換: endAdornment の旧名称
  inputStyle,
  className = '',
  wrapperClassName = '',
  ...props
}) {
  const inputId = props.id || props.name || `input-${Math.random().toString(36).substr(2, 9)}`;
  const rightSlot = endAdornment || iconRight;

  return (
    <div className={`leading-normal ${wrapperClassName}`}>
      {label && (
        <label htmlFor={inputId} style={LABEL_STYLE}>
          {label}
          {required && <span style={{ color: C.error, marginLeft: 2 }}>*</span>}
        </label>
      )}
      <div className="hud-scanline relative flex items-center">
        {icon && (
          <div
            className="absolute left-0 top-1/2 -translate-y-1/2 pointer-events-none"
            style={{ color: C.outline }}
          >
            {typeof icon === 'string'
              ? <span className="material-symbols-outlined" style={{ fontSize: '20px' }}>{icon}</span>
              : icon}
          </div>
        )}
        <input
          id={inputId}
          style={{
            ...INPUT_BASE_STYLE,
            paddingLeft: icon ? '28px' : '0',
            paddingRight: rightSlot ? '28px' : '0',
            borderBottomColor: error ? C.error : C.outlineVariant,
            ...inputStyle,
          }}
          className={`w-full bg-transparent focus:outline-none focus:ring-0 ${className}`}
          {...props}
        />
        {rightSlot && (
          <div className="absolute right-0 top-1/2 -translate-y-1/2">
            {rightSlot}
          </div>
        )}
      </div>
      {error && (
        <p style={{ marginTop: 4, fontSize: 12, color: C.error, fontFamily: "'Noto Sans JP', sans-serif" }}>
          {error}
        </p>
      )}
    </div>
  );
}

// Textarea variant
export function Textarea({
  label,
  error,
  required,
  inputStyle,
  className = '',
  wrapperClassName = '',
  rows = 4,
  ...props
}) {
  const textareaId = props.id || props.name || `textarea-${Math.random().toString(36).substr(2, 9)}`;

  return (
    <div className={`leading-normal ${wrapperClassName}`}>
      {label && (
        <label htmlFor={textareaId} style={LABEL_STYLE}>
          {label}
          {required && <span style={{ color: C.error, marginLeft: 2 }}>*</span>}
        </label>
      )}
      <div className="hud-scanline">
        <textarea
          id={textareaId}
          rows={rows}
          style={{
            ...INPUT_BASE_STYLE,
            borderBottomColor: error ? C.error : C.outlineVariant,
            resize: 'vertical',
            ...inputStyle,
          }}
          className={className}
          {...props}
        />
      </div>
      {error && (
        <p style={{ marginTop: 4, fontSize: 12, color: C.error, fontFamily: "'Noto Sans JP', sans-serif" }}>
          {error}
        </p>
      )}
    </div>
  );
}
